<div class="bg-image">
  <div class="container">
    <div class="d-flex justify-content-center h-100">
      <div class="card">
        <div class="card-body">
          <form>
            <div style="margin-bottom: 2%;">
              <img title="Login" alt="Login" src="../assets/images/CCPN_login_icon.png"> <span
                style="color:white;font-size: 20px;padding:12px;font-weight:bold;" title="Login">Login</span>
            </div>

            <div tabindex="0" class="input-group form-group">
              <input type="text" id="loginusername" class="form-control" tabindex="1" title="Email"
                (keydown.enter)="validateUser()" [(ngModel)]="userID" aria-label="Email" name="username"
                placeholder="COJ Email">
            </div>
            <div tabindex="0" class="input-group form-group">
              <input type="password" id="loginpassword" class="form-control" tabindex="2" title="Password"
                [(ngModel)]="Password" aria-label="Password" type="password" name="Password" placeholder="password">
            </div>
            <!-- <div tabindex="0" class="input-group form-group g-recaptcha">
              <re-captcha class="rc-imageselect g-recaptcha" title="recaptcha" (resolved)="resolved($event)"
                siteKey='6LfCB8sUAAAAAF0FkQ9uUNkkjjnAXb_vdOF__7Zg'>
              </re-captcha>
            </div> -->
            <!-- [disabled] = "adisable" -->
            <div tabindex="0" class="form-group">
              <input type="Button" tabindex="0" id="Login" title="Login" role="button" value="Login"
                style="cursor:pointer;" (click)="validateUser()" class="btn float-left login_btn">
              <div tabindex="0" *ngIf="disMessage!=''">
                <span class="btn btn-danger" style="white-space: pre-wrap;">
                  <p> {{disMessage}}</p>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
